export enum BillingRecurringTypes {

    Monthly = 1,
    Yearly = 2

}

export interface IPriceBillingCycle {

    Price: number;
    Setup: number;
    BillingCycle: BillingRecurringTypes;

    TaxEnabled: boolean;
    TaxRate: number;
    State: string;
    TaxRateDisplay: string;
    TotalWithTax: string;
    TaxAmount: number;

}

export class PriceBillingCycle implements IPriceBillingCycle {

    Price: number;
    Setup: number;
    BillingCycle: BillingRecurringTypes;

    TaxEnabled: boolean;
    TaxRate: number;
    State: string;
    TaxRateDisplay: string;
    TotalWithTax: string;
    TaxAmount: number;

}

export class PriceBillingCycleArray extends Array<PriceBillingCycle> {

    constructor(...items: PriceBillingCycle[]) {
        super(...items);
        Object.setPrototypeOf(this, PriceBillingCycleArray.prototype);
    }
}